import { render, staticRenderFns } from "./sensors.vue?vue&type=template&id=5763af95&lang=pug&"
import script from "./sensors.vue?vue&type=script&lang=js&"
export * from "./sensors.vue?vue&type=script&lang=js&"
import style0 from "./sensors.vue?vue&type=style&index=0&id=5763af95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports